import { render, staticRenderFns } from "./ReferralHistoryTable.vue?vue&type=template&id=6e5c8980"
import script from "./ReferralHistoryTable.vue?vue&type=script&lang=js"
export * from "./ReferralHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports